import React, { useRef } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { getVersionData } from "@redux/version/selector";
import InBodyInterviewMeasureNormalBox from "@icoach/inbody/components/InBodyInterviewMeasureNormalBox";
import ScrollerArrowButton from "@icoach/inbody/components/ScrollerArrowButton";
import { Box } from "@curves/ui-base";
import useFrozenTableCells from "@util/hook/useFrozenTableCells";

const MeasureRecordTable = ({ className, sourceData = [], measureItems = [] }) => {
	const reduxVersion = useSelector(getVersionData);
	let { env: ENV = "" } = reduxVersion;

	const { tableContainerRef, frozenCellsRef } = useFrozenTableCells();

	const divRef = useRef(null);

	return (
		<Box ref={tableContainerRef} className={clsx("inbody-measure scroll-arrow-container", className)}>
			<Box className={"container"} ref={divRef}>
				{measureItems.map(({ value, key, rowClass, formatCell, style: styleProps = {}, env, recordHidden = false }, i) => {
					if ((env && !env.includes(String(ENV).toUpperCase())) || recordHidden) {
						return null;
					}
					let styles = { ...styleProps };
					return (
						// row
						<Box key={value} className={clsx("row", rowClass, sourceData.length === 0 && "full-width")}>
							{/* Column 標題 */}
							<Box ref={el => (frozenCellsRef.current[i] = el)} className={clsx("item", "sticky", "label")} style={{ width: "180px" }}>
								{value}
							</Box>
							{/*/!* 全部內容 *!/*/}
							<InBodyInterviewMeasureNormalBox sourceData={sourceData} itemKey={key} styles={styles} formatCell={formatCell} />
						</Box>
					);
				})}
			</Box>
			<ScrollerArrowButton arrowLeftPos={600} parentRef={divRef} />
		</Box>
	);
};

export default MeasureRecordTable;
